// Action buttons (modal footers, forms): the filled brand button runs the
// action, the outlined one cancels or goes back. Both are h-9.5, a little taller than
// the list toolbar controls. Add spacing at the call site.
export const PRIMARY_BUTTON =
  "inline-flex items-center justify-center gap-2 h-9.5 rounded-lg bg-brand px-4 text-sm font-medium text-white hover:bg-brand-strong focus:outline-hidden focus:ring-4 focus:ring-brand/30 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-brand";

export const SECONDARY_BUTTON =
  "inline-flex items-center justify-center gap-2 h-9.5 rounded-lg border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 hover:bg-slate-100 hover:text-black focus:z-10 focus:outline-hidden focus:ring-4 focus:ring-brand/30";
